import Page from "./ScanningOnly";

export default Page;
